/**
 * @deprecated Use the `User` type from "@dobrh-monorepo/core" instead
 */
export type UserModel = {
  _id: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  email: string;
  password?: string;
  roleId?: string;
  country?: string;
  createdAt?: Date;
  updatedAt?: Date;
  socialLogin?: SocialLogin;
  primaryAddress: any;
  billingAddress: any;
  timezone?: string;
  gender?: 0 | 1 | 2;
  stripeCustId?: string;
  stripeCustCognifleId?: string;
  stripeSubCognifleId?: string;
  stripeCards?: StripeCard[];
  paypalPayerId?: string;
  paypalAccId?: string[];
  payoneerFullName?: string;
  payoneerEmail?: string;
  loginHistory: LoginHistory[];
  profileImage?: string;
  paymentMethod?: string;
  phone?: string;
  talentStatus?: {
    isTalent?: number;
    talentDate?: TalentDate[];
  };
  isPaymentVerified?: 0 | 1;
  isVerified?: 0 | 1;
  isDocumentVerified?: 0 | 1 | 2;
  paymentStatus?: boolean;
  status?: 0 | 1;
  emailNotification?: 0 | 1;
  activeStatus?: 0 | 1 | 2;
  accountStatus?: "BLOCKED" | "UNBLOCKED";
  deleteInfo?: DeleteInfo;
  membership?: 0 | 1 | 2 | 3;
  membershipBenefits?: UserMembershipBenefits;
  nameVisibility?: 0 | 1;
  isPhoneNumberVerified?: boolean;
  twoFactorAuth: {
    email: boolean;
    sms: boolean;
  };
  professionalMessage?: boolean;
  securityQuestions?: SecurityQuestion[];
  notificationSettings?: NotificationSettings;
  visibleOnProfile?: { phone?: boolean; email?: boolean };
  fieldUpdates?: FieldUpdates;
};

export enum USER_GENDER_ENUM {
  UNDEFINED = 0,
  MALE = 1,
  FEMALE = 2,
}

type SocialLogin = {
  socialId?: string;
  socialType?: "GOOGLE" | "APPLE";
};

export type StripeCard = {
  id?: string;
  customer?: string;
  exp_month?: string;
  exp_year?: string;
  brand?: string;
  last4?: string;
  isPrimary?: boolean;
  isVerified?: boolean;
};

type LoginHistory = {
  location?: {
    city?: string;
    state?: string;
    country?: string;
    address?: string;
  };
  deviceId?: string;
  deviceType?: string;
  loginAt?: Date;
};

type TalentDate = {
  month?: number;
  year?: number;
};

export type SecurityQuestion =
  | {
      Questions?: string;
      Answer?: string;
    }
  | undefined;

export type NotificationSettings = {
  accountActivity: {
    push: boolean;
    email: boolean;
  };
  projectUpdates: {
    push: boolean;
    email: boolean;
  };
  reviewsAndRatings: {
    push: boolean;
    email: boolean;
  };
  featured: {
    push: boolean;
    email: boolean;
  };
  news: {
    push: boolean;
    email: boolean;
  };
  promotions: {
    push: boolean;
    email: boolean;
  };
};

type FieldUpdates = {
  password?: { updatedAt?: Date };
};

type DeleteInfo = {
  isDelete?: boolean;
  deleteDate?: Date;
  reason?: string;
};

export type UserMembershipBenefits = {
  membershipServiceSlots?: number;
  purchasedServiceSlots?: number;
  eligibleForFreeTrial?: boolean;
};
